import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -9 58 58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("circle", {
        cx: "29",
        cy: "20",
        r: "29",
        "fill-opacity": ".12"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "M24 1h12v12h12v12H36v12H24V25H12V13h12z"
      })
    ], -1)
  ]))]))
}
export default { render: render }